/* js/employee-slider.js */

;(function ($, window, document) {

    $(document).ready(function () {

        if (typeof $.fn.slick == 'function') {

            var $target = $('.intranet--home .employee__list');

            if ($target.length == 0) {
                return;
            }

            $parent = $target.parent();

            var config = {
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
            };

            if ($parent.hasClass('autoplay')) {
                config.autoplay = true;
            }

            $('.intranet--home .employee__list').slick(config);

        }

    });

})(jQuery, window, document);